<template>
  <div>
    <p>
      Please enter your preferences for your digital voucher pass here on.
    </p>
    <br />
    <label>Make your selection here:</label>
    <CategoryCheckboxList
      v-on:change="handleChecboxChange"
      :categoryIds="categories"
    />

    <Button label="Next" v-on:click="handleSubmit" />
  </div>
</template>

<script>
import CategoryCheckboxList from "@/components/CategoryCheckboxList.vue";
import Button from "@/components/Button.vue";
import { isIOS, isAndroid } from "mobile-device-detect";
import allCategories from "../constants/categories";
import Axios from "axios";

export default {
  //layout: (ctx) => (ctx.isMobile ? 'mobile' : 'default')

  components: {
    CategoryCheckboxList,
    Button
  },

  data: () => {
    return { categories: [] };
  },

  methods: {
    handleChecboxChange(data) {
      this.categories = data;
    },

    async handleSubmit() {
      this.$store.commit("loading", true);
      try {
        const dynamicData = {};
        allCategories.forEach(cat => {
          dynamicData[cat.id] = this.categories.includes(cat.id)
            ? ""
            : "disabled";
        });

        const body = {
          dynamicData: dynamicData
        };

        const response = await Axios.post(
          process.env.VUE_APP_API_URLBASE + "/pass",
          body
        );
        const passId = response.data.id;
        if (isIOS) {
          this.$router.push(`/ios/success/1/${passId}`);
        }
        if (isAndroid) {
          this.$router.push(`/android/success/${passId}`);
        }
      } catch (e) {
        // TODO - handle
      }
      this.$store.commit("loading", false);
    }
  }
};
</script>
